import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import JobForm from '../../components/Form/JobForm';
import Header from '../../components/utility/Header';
import { showErrorToast, showSuccessToast } from '../../components/ui/Toast';
import { useAuthContext } from '../../context/AuthProvider';
import Container from '../../components/Cards/Container';
import { getRoute, ROUTE_KEY } from '../../config/permissions.config';
import { createJob } from '../../services/jobs.service';

const CreateJobs = () => {
  const navigate = useNavigate();
  const { user } = useAuthContext(); // Get user data from the context
  const role = user?.role || 'Admin';

  const createJobMutation = useMutation({
    mutationFn: createJob,
    onSuccess: (data) => {
      const action = data.status === 'draft' ? 'saved as draft' : 'created';
      showSuccessToast('Job Action', `"${data.jobTitle}" ${action} successfully`);
      navigate(getRoute(role,ROUTE_KEY.ALLJOBS));  
    },
    onError: (error) => {
      // console.error('Error with job action:', error);
      showErrorToast('Error', error.response?.data?.message || 'Failed to perform job action. Please try again.');
    }
  });

  const handleSubmit = (data, isDraft = false) => {
    const status = isDraft ? 'draft' : 'open';
    createJobMutation.mutate({ ...data, status });
  };

  return (
    <Container hasBgColor>
        <Header HeaderText="Create a New Job Listing" withBack="true" />
        <JobForm
          isLoading={createJobMutation.isPending}
          onSubmit={handleSubmit}
          isEditing={false}
        />
    </Container>
  );
};

export default CreateJobs;